export default "__VITE_ASSET__BQbkDAdI__"